import React, { useRef, useState, useEffect, useCallback } from "react"
import Slider from '@material-ui/core/Slider';
import Fab from '@material-ui/core/Fab';
import PlayIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { RenderMarkdown } from '../../core/render-markdown.component'

import './leveled-reader.scss';

const LeveledReaderAudioPlayer = ({ audioSrc }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioEl = useRef(null);
  const setPlayerDuration = useCallback(() => {
    if (audioEl && audioEl.current) {
      setDuration(audioEl.current.duration);
    }
  }, []);
  const setPlayerCurrentTime = useCallback(() => {
    if (audioEl && audioEl.current) {
      setCurrentTime(audioEl.current.currentTime);
    }
  }, []);
  const onAudioEnded = useCallback(() => {
    if (audioEl && audioEl.current) {
      audioEl.current.currentTime = 0;
      setIsPlaying(false);
    }
  }, []);
  const playAudio = useCallback(() => {
    if (audioEl && audioEl.current) {
      audioEl.current.play();
      setIsPlaying(true);
    }
  }, []);
  const pauseAudio = useCallback(() => {
    if (audioEl && audioEl.current) {
      audioEl.current.pause();
      setIsPlaying(false);
    }
  }, []);
  const scrubAudio = useCallback((event, newValue) => {
    if (audioEl && audioEl.current) {
      audioEl.current.currentTime = newValue;
    }
  }, []);
  useEffect(() => {
    if (audioEl && audioEl.current) {
      if (audioEl.current.readyState > 3) {
        setPlayerDuration();
      } else {
        audioEl.current.addEventListener('canplay', setPlayerDuration);
      }
      audioEl.current.addEventListener('timeupdate', setPlayerCurrentTime);
      audioEl.current.addEventListener('ended', onAudioEnded);
    }
    return () => {
      if (audioEl && audioEl.current) {
        audioEl.current.removeEventListener('canplay', setPlayerDuration);

        audioEl.current.removeEventListener(
          'timeupdate',
          setPlayerCurrentTime
        );
        audioEl.current.removeEventListener('ended', onAudioEnded);
      }
    };
  }, [audioEl]);
  return (
    <div className="audio-player-wrapper">
      <audio ref={audioEl} src={audioSrc} preload="auto" hidden />
      <div className="audio-player-pod">
        {
          isPlaying
          ? (
            <Fab size="small" onClick={pauseAudio} style={{minWidth:40}}>
              <PauseIcon />
            </Fab>
          ) : (
            <Fab size="small" onClick={playAudio} style={{minWidth:40}}>
              <PlayIcon />
            </Fab>
          )
        }
        <Slider
          value={currentTime > 0 ? currentTime : []}
          track={currentTime > 0 && 'normal'}
          min={0}
          max={duration}
          onChange={scrubAudio}
        />
      </div>
    </div>
  );
}

export const LeveledReaderSyllables =  ({ audioSrc, children }) => {
  const audioEl = useRef(null);
  const playAudio = useCallback(() => {
    if (audioEl && audioEl.current) {
      audioEl.current.currentTime = 0;
      audioEl.current.play();
    }
  }, []);
  return (
    <button className="leveled-reader-syllables" onClick={playAudio}>
      <audio ref={audioEl} src={audioSrc} preload="auto" hidden />
      { children }
    </button>
  )
}

export const LeveledReaderTitleSlide =  ({ index, currentSlide, image, title }) => {
  return (
    <>
      <img className="hero-image" src={image} alt="" />
      <div className="content-zone">
        <h2 outlinetext={title}>{title}</h2>
      </div>
    </>
  )
}

export const LeveledReaderContentSlide =  ({ index, currentSlide, image, audio, content }) => {
  return (
    <>
      <img className="hero-image" src={image} alt="" />
      <div className="content-zone">
        <div className="text-content">
          <RenderMarkdown md={content} />
        </div>
        { audio &&
          <LeveledReaderAudioPlayer audioSrc={audio} />
        }
      </div>
    </>
  )
}

export const LeveledReaderNavButton =  ({ icon, onClick }) => (
  <div className="nav-button-wrapper">
    <Fab size="large" onClick={onClick}>
      { icon }
    </Fab>
  </div>
);

export const LeveledReaderSlide =  ({ index, currentSlide, totalSlides, setCurrentSlide, type, ...childProps }) => {
  const isCurrentSlide = (index === currentSlide);
  const distanceToCurrent = index-currentSlide;
  const Component = SLIDE_COMPONENT_TYPES[type];
  let className = 'leveled-reader-slide';
  if(type === 'title') {
    className += ' leveled-reader-title-slide';
  }
  if(isCurrentSlide) {
    className += ' current-slide';
  }

  return (
    <div className={className} style={{ zIndex: -Math.abs(distanceToCurrent), transform: `translateX(${distanceToCurrent*5}vw)` }}>
      <Component {...childProps} />
    </div>
  )
}

const SLIDE_COMPONENT_TYPES = {
  title: LeveledReaderTitleSlide,
  content: LeveledReaderContentSlide
};

export const LeveledReader = ({ slides }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  if(slides && slides.length){
    const slideComponents = slides.map((slide, i) => (
      <LeveledReaderSlide key={i} index={i}  currentSlide={currentSlide} setCurrentSlide={setCurrentSlide} {...slide} />
    ))
    return (
      <div className="leveled-reader">
        {currentSlide > 0 && <LeveledReaderNavButton icon={<ArrowBackIcon />} onClick={() => setCurrentSlide(currentSlide-1)} />}
        <div className="leveled-reader-slide-collection">
          { slideComponents }
        </div>
        {currentSlide < slides.length-1 && <LeveledReaderNavButton icon={<ArrowForwardIcon />} onClick={() => setCurrentSlide(currentSlide+1)} />}
      </div>
    );
  } else {
    return (
      <div>NO SLIDES</div>
    );
  }
}